module.exports = __webpack_public_path__ + "static/img/light_hand.61f3dd9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light_hand.jpeg
// module id = LTmB
// module chunks = 0